var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrainstorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91405 0.3125C3.71576 0.3125 0.312378 3.71588 0.312378 7.91417C0.312378 12.1124 3.71576 15.5158 7.91405 15.5158C12.1123 15.5158 15.5157 12.1124 15.5157 7.91417C15.5157 3.71588 12.1123 0.3125 7.91405 0.3125ZM7.32674 5.30607L5.79498 6.52588C5.15232 7.03762 4.83099 7.29357 4.89371 7.57924L4.89705 7.59338C4.96851 7.8773 5.37582 7.98646 6.19044 8.20478C6.64312 8.32603 6.8695 8.38669 6.9757 8.55826L6.98109 8.5673C7.08356 8.74093 7.02526 8.95841 6.90873 9.39338L6.87824 9.50702C6.5551 10.713 6.39355 11.3158 6.7047 11.5106C7.01583 11.7053 7.51093 11.3111 8.50112 10.5226L10.0329 9.30277C10.6755 8.79102 10.9968 8.53515 10.9341 8.2494L10.9308 8.23526C10.8593 7.95134 10.452 7.84218 9.63742 7.62394C9.18474 7.50261 8.95836 7.44195 8.85217 7.27038L8.84677 7.26134C8.7443 7.08772 8.80261 6.87023 8.91914 6.43534L8.94962 6.32162C9.27269 5.11572 9.4343 4.51278 9.12309 4.31806C8.81196 4.12334 8.31686 4.51758 7.32674 5.30607Z",
    fill: "url(#paint0_linear_26286_40917)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26286_40917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3437 17.6876C10.9446 17.6876 8.99988 15.7429 8.99988 13.3438C8.99988 10.9447 10.9446 9 13.3437 9C15.7428 9 17.6875 10.9447 17.6875 13.3438C17.6875 15.7429 15.7428 17.6876 13.3437 17.6876Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6856 15.4085L14.2969 14.3716C14.329 14.3284 14.3735 14.2963 14.4248 14.2785L15.6021 14.0307C15.7719 13.9725 15.8376 13.7672 15.7322 13.6214L14.9286 12.7329C14.8978 12.6905 14.8807 12.6405 14.878 12.5885L14.9519 11.4269C14.9444 11.2565 14.7808 11.1367 14.6158 11.1812L13.546 11.6823C13.5015 11.6946 13.4543 11.6946 13.4091 11.6829L12.3084 11.1908C12.1449 11.1477 11.9833 11.2661 11.9744 11.4345L12.0258 12.6056C12.023 12.6542 12.0073 12.7014 11.9792 12.7418L11.2188 13.6275C11.1195 13.7726 11.1852 13.9718 11.3502 14.03L12.5323 14.2792C12.5802 14.2963 12.6226 14.3264 12.6541 14.3668L13.2612 15.4133C13.3694 15.5516 13.5802 15.5496 13.6856 15.4085Z",
    fill: "url(#paint1_linear_26286_40917)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26286_40917",
    x: 5.17098,
    y: 5.1711,
    width: 16.3454,
    height: 16.3453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.91445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26286_40917"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26286_40917",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26286_40917",
    x1: -0.00435813,
    y1: -1.50873,
    x2: 15.4365,
    y2: 15.7534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26286_40917",
    x1: 11.172,
    y1: 11.5112,
    x2: 15.3289,
    y2: 15.5139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainstorm);
export default __webpack_public_path__ + "static/media/brainstorm.3abc9a12c06f5c69c202f370406e91b1.svg";
export { ForwardRef as ReactComponent };